( function ( $ ) {
	if ( $( '.checklist__list' ).length > 0 ) {
		$( '.checklist__item__title' ).on( 'click', function () {
			$( this ).parent().toggleClass( 'checklist-open' );
		} );
		$( '.checklist__item__title__checkbox' ).on( 'click', function () {
			$( this ).toggleClass( 'open' );
			return false;
		} );
	}
} )( jQuery );
